export default {
    tableRowClassName: ({ row, rowIndex }) => {
      if (rowIndex % 2 === 1) {
        return { background: '#ffffff' }
      }
    },
    tableStyle: () => {
      return { width: 'calc(100% - 24px)', 'margin-left': '12px', 'font-size': '16px', color: '#000' }
    },
    cellStyle: () => {
      return { padding: 'o.9vh', 'font-weight ': 500, 'font-size': '14px' }
    },
    headCellStyle: () => {
      return { background: '#f8f8f9', color: '#00', padding: '.5vh 0 !important', 'font-size': '0.8ww' }
    }
  }
  


// WEBPACK FOOTER //
// ./src/api/filters.js